const sortByNameAlphabetically = (items, getName = (item) => item?.name) => [...items].sort((left, right) => (
  String(getName(left) || '').localeCompare(String(getName(right) || ''), undefined, { sensitivity: 'base' })
));

export default sortByNameAlphabetically;
